module.exports = __webpack_public_path__ + "static/media/gps-rojo.c10b8773.svg";